import { IUserInChatListSchema, TChatRole } from '../types/userData';

export const getChatUserByRole = (users: IUserInChatListSchema[] | undefined, role: TChatRole) =>
  users?.find(user => user.chatRole === role);
